import { useIntl } from 'react-intl';
import {
	UserSegmentTypes,
	useUserSegments,
} from 'src/uniform/components/personalization-container/src/use-user-segments';

import UFOSegment from '@atlaskit/react-ufo/segment';

import { useRovoEnabledCohort } from '@/components/user-context/helpers/cohorts';
import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';
import { LogoV3 } from '@/libraries/wpl/foundations/src/logo-v3';
import { ProductPageSubNav } from '@/patterns/global-nav/src/nav-product-page';
import { useLoggedInUser } from '@/utils/logged-in-user-provider';

export const RovoNav = () => {
	const intl = useIntl();

	const navLinks = [
		{
			globalLinksKey: 'features',
			linkText: intl.formatMessage({
				id: 'RovoPageTemplate.navbar.features',
				defaultMessage: 'Features',
			}),
			hasSubnav: false,
			productKey: 'rovo',
			href: useLocalizedHref('/software/rovo/features'),
		},
		{
			globalLinksKey: 'connectors',
			linkText: intl.formatMessage({
				id: 'RovoPageTemplate.navbar.connectors',
				defaultMessage: 'Connectors',
			}),
			hasSubnav: false,
			productKey: 'rovo',
			href: useLocalizedHref('/software/rovo/connectors'),
		},
		{
			globalLinksKey: 'use-cases',
			linkText: intl.formatMessage({
				id: 'RovoPageTemplate.navbar.use-cases',
				defaultMessage: 'Use cases',
			}),
			hasSubnav: false,
			productKey: 'rovo',
			href: useLocalizedHref('/software/rovo/use-cases'),
		},
		{
			globalLinksKey: 'guides',
			linkText: intl.formatMessage({
				id: 'RovoPageTemplate.navbar.guides',
				defaultMessage: 'Guides',
			}),
			hasSubnav: false,
			productKey: 'rovo',
			href: useLocalizedHref('/software/rovo/guides/end-user-guide/introduction'),
		},
		{
			globalLinksKey: 'licensing',
			linkText: intl.formatMessage({
				id: 'RovoPageTemplate.navbar.licensing',
				defaultMessage: 'Licensing',
			}),
			hasSubnav: false,
			productKey: 'rovo',
			href: useLocalizedHref('/licensing/rovo'),
		},
	];

	const { requestInProgress } = useLoggedInUser();
	const { data: userSegments } = useUserSegments();
	const isRovoEnabledCohort = useRovoEnabledCohort();

	const isRovoInPlanList =
		userSegments?.[UserSegmentTypes.OWNED_PRODUCTS]?.includes('rovo.ondemand');

	const defaultCTAUrl = useLocalizedHref(
		'/try/cloud/signup?bundle=teamwork-collection&primaryCollectionProduct=rovo.ondemand&edition=premium',
	);

	const isUserLoggedInAndCtasEnabledAndInPlan = isRovoInPlanList;

	const ctaText = intl.formatMessage({
		id: 'RovoPageTemplate.navbar.cta.try-rovo',
		defaultMessage: 'Try Rovo',
	});

	const tryNowCTAUrl = isUserLoggedInAndCtasEnabledAndInPlan
		? 'https://home.atlassian.com/chat'
		: defaultCTAUrl;

	const isShowTryNowLink = !requestInProgress && tryNowCTAUrl && ctaText ? true : false;

	const buttonVariant = isRovoEnabledCohort ? 'secondary' : 'primary';

	return (
		<UFOSegment name="RovoNav">
			<ProductPageSubNav
				productLogoUrl="/software/rovo"
				productLogo={<LogoV3 brand="rovo" type="logo" appearance="brand" />}
				productLogoAriaLabel={intl.formatMessage({
					id: 'RovoPageTemplate.navbar.rovo-logo',
					defaultMessage: 'Rovo logo',
				})}
				mobileLogo={<LogoV3 brand="rovo" type="logo" appearance="brand" />}
				isShowTryNowLink={isShowTryNowLink}
				isIncludeMobileCTA={isShowTryNowLink}
				navigationTrynowCtaText={isShowTryNowLink ? ctaText : undefined}
				navigationTrynowCtaUrl={isShowTryNowLink ? tryNowCTAUrl : undefined}
				navigationTrynowCtaButtonVariant={buttonVariant}
				mobileCtaText={isShowTryNowLink ? ctaText : undefined}
				mobileCtaUrl={isShowTryNowLink ? tryNowCTAUrl : undefined}
				mobileCtaButtonVariant={buttonVariant}
				productPageNavLinks={navLinks}
				mobileLinksSections={[
					{
						mobileLinkKey: 'mobile-rovo',
						mobileLinksProps: navLinks,
					},
				]}
			/>
		</UFOSegment>
	);
};
